(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menara-comparateur"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mc]').forEach(function (root) {
    var scene = root.querySelector('.mc__scene');
    var curseur = root.querySelector('[data-mc-curseur]');
    if (!scene || !curseur) return;
    function appliquer() {
      scene.style.setProperty('--mc-pos', curseur.value + '%');
    }
    curseur.addEventListener('input', appliquer, { passive: true });
    appliquer();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menara-ensembles-v2"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-me2]').forEach(function (root) {
    var piste = root.querySelector('[data-me2-piste]');
    var barre = root.querySelector('[data-me2-barre]');
    var num = root.querySelector('[data-me2-num]');
    if (!piste) return;
    var cartes = piste.querySelectorAll('.me2__carte');
    function pas() { return cartes.length ? cartes[0].offsetWidth + 20 : 300; }
    var prec = root.querySelector('[data-me2-prec]');
    var suiv = root.querySelector('[data-me2-suiv]');
    if (prec) prec.addEventListener('click', function () { piste.scrollBy({ left: -pas(), behavior: 'smooth' }); });
    if (suiv) suiv.addEventListener('click', function () { piste.scrollBy({ left: pas(), behavior: 'smooth' }); });
    function maj() {
      var max = piste.scrollWidth - piste.clientWidth;
      if (barre) {
        var visible = max <= 0 ? 100 : (piste.clientWidth / piste.scrollWidth) * 100;
        var pos = max <= 0 ? 0 : (piste.scrollLeft / max) * (100 - visible);
        barre.style.width = visible + '%';
        barre.style.marginLeft = pos + '%';
      }
      if (num && cartes.length) {
        var i = Math.min(cartes.length, Math.round(piste.scrollLeft / pas()) + 1);
        num.textContent = (i < 10 ? '0' : '') + i;
      }
    }
    piste.addEventListener('scroll', maj, { passive: true });
    window.addEventListener('resize', maj);
    maj();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menara-entete"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-me]').forEach(function (root) {
    var items = root.querySelectorAll('[data-me-item]');
    var minuteur = null;

    function toutFermer(sauf) {
      items.forEach(function (item) {
        if (item === sauf) return;
        item.classList.remove('est-ouvert');
        var d = item.querySelector('[data-me-declencheur]');
        if (d) d.setAttribute('aria-expanded', 'false');
      });
    }
    items.forEach(function (item) {
      var declencheur = item.querySelector('[data-me-declencheur]');
      if (!declencheur) return;
      function ouvrir() {
        clearTimeout(minuteur);
        toutFermer(item);
        item.classList.add('est-ouvert');
        declencheur.setAttribute('aria-expanded', 'true');
      }
      item.addEventListener('mouseenter', ouvrir);
      item.addEventListener('mouseleave', function () {
        minuteur = setTimeout(function () {
          item.classList.remove('est-ouvert');
          declencheur.setAttribute('aria-expanded', 'false');
        }, 160);
      });
      declencheur.addEventListener('click', function () {
        if (item.classList.contains('est-ouvert')) {
          item.classList.remove('est-ouvert');
          declencheur.setAttribute('aria-expanded', 'false');
        } else {
          ouvrir();
        }
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') toutFermer(); });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) toutFermer(); });

    var panneauRecherche = root.querySelector('[data-me-panneau-recherche]');
    root.querySelectorAll('[data-me-recherche], [data-me-recherche-basse]').forEach(function (bouton) {
      if (!panneauRecherche) return;
      bouton.addEventListener('click', function () {
        panneauRecherche.hidden = !panneauRecherche.hidden;
        if (!panneauRecherche.hidden) {
          var champ = panneauRecherche.querySelector('input');
          if (champ) champ.focus();
        }
      });
    });

    // La barre du bas doit vivre hors de l'en-tete : celui-ci se masque au
    // defilement et emporterait la barre avec lui.
    var barreBasse = root.querySelector('[data-me-basse]');
    if (barreBasse) document.body.appendChild(barreBasse);

    var burger = root.querySelector('[data-me-burger]');
    var tiroir = root.querySelector('[data-me-tiroir]');
    if (burger && tiroir) {
      burger.addEventListener('click', function () {
        tiroir.hidden = false;
        burger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        // La barre du bas s'efface : le tiroir occupe deja tout l'ecran.
        document.body.classList.add('me-tiroir-ouvert');
        setTimeout(function () { tiroir.classList.add('est-ouvert'); }, 20);
      });
      tiroir.querySelectorAll('[data-me-fermer]').forEach(function (b) {
        b.addEventListener('click', function () {
          tiroir.classList.remove('est-ouvert');
          burger.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
          document.body.classList.remove('me-tiroir-ouvert');
          setTimeout(function () { tiroir.hidden = true; }, 300);
        });
      });
    }

    var annonces = root.querySelectorAll('[data-me-annonce-item]');
    if (annonces.length > 1) {
      var index = 0;
      function afficher(i) {
        index = (i + annonces.length) % annonces.length;
        annonces.forEach(function (a, k) { a.classList.toggle('is-actif', k === index); });
      }
      // Defilement automatique ; les fleches forcent le passage et
      // relancent le compte a rebours pour laisser le temps de lire.
      var minuteur = null;
      function relancer() {
        if (minuteur) clearInterval(minuteur);
        minuteur = setInterval(function () { afficher(index + 1); }, 5000);
      }
      var p = root.querySelector('[data-me-annonce-prec]');
      var s = root.querySelector('[data-me-annonce-suiv]');
      if (p) p.addEventListener('click', function () { afficher(index - 1); relancer(); });
      if (s) s.addEventListener('click', function () { afficher(index + 1); relancer(); });
      var barreAnnonce = root.querySelector('[data-me-annonce]');
      if (barreAnnonce) {
        barreAnnonce.addEventListener('mouseenter', function () { if (minuteur) clearInterval(minuteur); });
        barreAnnonce.addEventListener('mouseleave', relancer);
      }
      relancer();
    }

    var groupe = document.getElementById('header-group');
    if (groupe) {
      // Horizon fait defiler .page-wrapper, pas la fenetre : on detecte le
      // conteneur reellement scrollable pour y accrocher marge et ecouteur.
      var conteneur = document.querySelector('.page-wrapper');
      if (!conteneur || conteneur.scrollHeight <= conteneur.clientHeight + 4) conteneur = null;
      var cible = conteneur || document.body;

      function compenser() {
        cible.style.paddingTop = groupe.offsetHeight + 'px';
        // Publiee pour les colonnes collantes des autres sections.
        document.documentElement.style.setProperty('--me-hauteur', groupe.offsetHeight + 'px');
      }
      compenser();
      window.addEventListener('resize', compenser);
      if (window.ResizeObserver) new ResizeObserver(compenser).observe(groupe);

      // L'en-tete reste en place ; seul son fond change des le premier
      // defilement pour se detacher du contenu qui passe dessous.
      function position() { return conteneur ? conteneur.scrollTop : window.scrollY; }
      function refletDefilement() {
        groupe.classList.toggle('est-defile', position() > 4);
      }
      refletDefilement();
      (conteneur || window).addEventListener('scroll', refletDefilement, { passive: true });
    }

    document.addEventListener('cart:refresh', function () {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (panier) {
        var badge = root.querySelector('[data-me-compteur]');
        if (!badge) return;
        badge.textContent = panier.item_count;
        badge.hidden = panier.item_count === 0;
      }).catch(function () {});
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menara-format"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mfo]').forEach(function (root) {
      var cadre = root.querySelector('[data-mfo-cadre]');
      var dessin = root.querySelector('[data-mfo-dessin]');
      var photo = root.querySelector('[data-mfo-photo]');
      var dim = root.querySelector('[data-mfo-dim]');
      var pastilles = root.querySelectorAll('[data-mfo-pastille]');

      // Le meuble fait 54 % de la scene pour une console de 120 cm : une
      // oeuvre de 60 cm occupe donc 27 % de la largeur. Meme regle pour la
      // hauteur, en gardant les proportions reelles du format.
      var MEUBLE_CM = 120;
      var MEUBLE_PART = 54;

      function poser(p) {
        var lg = parseFloat(p.getAttribute('data-mfo-lg')) || 0;
        var ht = parseFloat(p.getAttribute('data-mfo-ht')) || 0;
        var img = p.getAttribute('data-mfo-image');

        pastilles.forEach(function (a) {
          a.classList.remove('est-active');
          a.setAttribute('aria-selected', 'false');
        });
        p.classList.add('est-active');
        p.setAttribute('aria-selected', 'true');

        if (dim) dim.textContent = p.getAttribute('data-mfo-valeur');

        if (img && photo) {
          photo.src = img;
          photo.hidden = false;
          if (dessin) dessin.style.display = 'none';
          return;
        }
        if (photo) photo.hidden = true;
        if (dessin) dessin.style.display = '';

        if (cadre && lg > 0 && ht > 0) {
          var pctL = (lg / MEUBLE_CM) * MEUBLE_PART;
          // La scene est en 4/3 : un pourcentage de hauteur vaut 4/3 d'un
          // pourcentage de largeur, il faut le corriger pour rester carre.
          var pctH = pctL * (ht / lg) * (4 / 3);
          cadre.style.width = pctL.toFixed(2) + '%';
          cadre.style.height = pctH.toFixed(2) + '%';
        }
      }

      pastilles.forEach(function (p) {
        p.addEventListener('click', function () { poser(p); });
        if (p.classList.contains('est-active')) poser(p);
      });

      // Les cartes de la fiche produit et les pastilles restent d'accord.
      document.querySelectorAll('[data-mp-option]').forEach(function (r) {
        r.addEventListener('change', function () {
          pastilles.forEach(function (p) {
            if (p.getAttribute('data-mfo-valeur') === r.value) poser(p);
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menara-interieurs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mi]').forEach(function (root) {
    var piste = root.querySelector('[data-mi-piste]');
    if (!piste) return;
    function pas() {
      var p = piste.querySelector('.mi__photo');
      return p ? p.offsetWidth + 14 : 280;
    }
    var prec = root.querySelector('[data-mi-prec]');
    var suiv = root.querySelector('[data-mi-suiv]');
    if (prec) prec.addEventListener('click', function () { piste.scrollBy({ left: -pas() * 2, behavior: 'smooth' }); });
    if (suiv) suiv.addEventListener('click', function () { piste.scrollBy({ left: pas() * 2, behavior: 'smooth' }); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menara-nouveautes"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mn]').forEach(function (root) {
    var piste = root.querySelector('[data-mn-piste]');
    var barre = root.querySelector('[data-mn-barre]');
    if (!piste) return;
    function pas() {
      var c = piste.querySelector('.mn__carte');
      return c ? c.offsetWidth + 20 : 300;
    }
    var prec = root.querySelector('[data-mn-prec]');
    var suiv = root.querySelector('[data-mn-suiv]');
    if (prec) prec.addEventListener('click', function () { piste.scrollBy({ left: -pas() * 2, behavior: 'smooth' }); });
    if (suiv) suiv.addEventListener('click', function () { piste.scrollBy({ left: pas() * 2, behavior: 'smooth' }); });
    function maj() {
      if (!barre) return;
      var max = piste.scrollWidth - piste.clientWidth;
      var visible = max <= 0 ? 100 : (piste.clientWidth / piste.scrollWidth) * 100;
      var pos = max <= 0 ? 0 : (piste.scrollLeft / max) * (100 - visible);
      barre.style.width = visible + '%';
      barre.style.marginLeft = pos + '%';
    }
    piste.addEventListener('scroll', maj, { passive: true });
    window.addEventListener('resize', maj);
    maj();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menara-produit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mp]').forEach(function (root) {
      // Vignettes : on retire srcset et sizes, sinon le navigateur ignore
      // le nouveau src et reaffiche l'ancien visuel.
      var principale = root.querySelector('[data-mp-principale]');
      function poser(src) {
        if (!principale || !src) return;
        principale.removeAttribute('srcset');
        principale.removeAttribute('sizes');
        principale.src = src;
      }
      var vignettes = Array.prototype.slice.call(root.querySelectorAll('[data-mp-vignette]'));
      function activer(i) {
        if (!vignettes.length) return;
        var k = (i + vignettes.length) % vignettes.length;
        vignettes.forEach(function (a) { a.classList.remove('est-active'); });
        vignettes[k].classList.add('est-active');
        poser(vignettes[k].getAttribute('data-mp-src'));
        vignettes[k].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      vignettes.forEach(function (v, i) {
        v.addEventListener('click', function () { activer(i); });
      });
      function courante() {
        for (var i = 0; i < vignettes.length; i++) {
          if (vignettes[i].classList.contains('est-active')) return i;
        }
        return 0;
      }
      var prec = root.querySelector('[data-mp-prec]');
      var suiv = root.querySelector('[data-mp-suiv]');
      if (prec) prec.addEventListener('click', function () { activer(courante() - 1); });
      if (suiv) suiv.addEventListener('click', function () { activer(courante() + 1); });

      var champ = root.querySelector('[data-mp-variantes]');
      var variantes = [];
      try { variantes = JSON.parse(champ.textContent); } catch (e) { variantes = []; }

      var champId = root.querySelector('[data-mp-id]');
      var champsPrix = root.querySelectorAll('[data-mp-prix]');
      var champRecap = root.querySelector('[data-mp-recap]');
      var bouton = root.querySelector('[data-mp-ajouter]');
      var boutonTexte = root.querySelector('[data-mp-ajouter-texte]');

      function choisies() {
        var v = [];
        root.querySelectorAll('[data-mp-option]:checked').forEach(function (r) { v.push(r.value); });
        return v;
      }

      function existe(combinaison) {
        for (var i = 0; i < variantes.length; i++) {
          var v = variantes[i];
          if (v.options.length !== combinaison.length) continue;
          var ok = true;
          for (var j = 0; j < combinaison.length; j++) {
            if (v.options[j] !== combinaison[j]) ok = false;
          }
          if (ok) return true;
        }
        return false;
      }

      // Une carte dont la combinaison n'existe pas se signale avant le clic :
      // c'est plus honnete que de laisser decouvrir l'impasse apres coup.
      function marquerImpossibles(sel) {
        root.querySelectorAll('[data-mp-option]').forEach(function (r) {
          var i = parseInt(r.getAttribute('data-mp-option'), 10) - 1;
          var essai = sel.slice();
          essai[i] = r.value;
          var carte = r.nextElementSibling;
          if (carte) carte.classList.toggle('est-indispo', !existe(essai));
        });
      }

      function accorder() {
        var sel = choisies();
        if (!sel.length || !variantes.length) return;
        var trouvee = null;
        variantes.forEach(function (v) {
          if (v.options.length !== sel.length) return;
          var ok = true;
          for (var i = 0; i < sel.length; i++) { if (v.options[i] !== sel[i]) ok = false; }
          if (ok) trouvee = v;
        });

        root.querySelectorAll('[data-mp-etape]').forEach(function (etape) {
          var i = parseInt(etape.getAttribute('data-mp-index'), 10);
          var libelle = etape.querySelector('[data-mp-valeur]');
          if (libelle && sel[i]) libelle.textContent = sel[i];
        });

        marquerImpossibles(sel);

        if (!trouvee) {
          // Aucune variante : on coupe court plutot que de laisser le prix
          // de la combinaison precedente, qui ferait croire a une offre.
          if (bouton) bouton.disabled = true;
          if (boutonTexte) boutonTexte.textContent = 'Combinaison indisponible';
          champsPrix.forEach(function (e) { e.textContent = '—'; });
          if (champRecap) champRecap.textContent = sel.join(' · ') + ' — non proposé';
          return;
        }
        if (champId) champId.value = trouvee.id;
        champsPrix.forEach(function (e) { e.textContent = trouvee.prix; });
        if (champRecap) champRecap.textContent = trouvee.titre;
        if (bouton) bouton.disabled = !trouvee.dispo;
        if (boutonTexte) boutonTexte.textContent = trouvee.dispo ? 'Ajouter au panier' : 'Épuisé';
        if (trouvee.image) poser(trouvee.image);
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', trouvee.id);
          window.history.replaceState({}, '', u.toString());
        }
      }

      root.querySelectorAll('[data-mp-option]').forEach(function (r) {
        r.addEventListener('change', accorder);
      });
      if (variantes.length > 1) marquerImpossibles(choisies());

      var qte = root.querySelector('[data-mp-qte]');
      var moins = root.querySelector('[data-mp-moins]');
      var plus = root.querySelector('[data-mp-plus]');
      if (qte && moins && plus) {
        moins.addEventListener('click', function () { qte.value = Math.max(1, (parseInt(qte.value, 10) || 1) - 1); });
        plus.addEventListener('click', function () { qte.value = (parseInt(qte.value, 10) || 1) + 1; });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menara-raconte"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mr]').forEach(function (root) {
    var onglets = root.querySelectorAll('[data-mr-onglet]');
    var panneaux = root.querySelectorAll('[data-mr-panneau]');
    onglets.forEach(function (o) {
      o.addEventListener('click', function () {
        var i = o.getAttribute('data-mr-onglet');
        onglets.forEach(function (x) {
          var actif = x === o;
          x.classList.toggle('is-actif', actif);
          x.setAttribute('aria-selected', actif ? 'true' : 'false');
        });
        panneaux.forEach(function (p) {
          p.classList.toggle('is-actif', p.getAttribute('data-mr-panneau') === i);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menara-univers"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mu]').forEach(function (root) {
    var pilules = root.querySelectorAll('[data-mu-filtre]');
    var items = root.querySelectorAll('[data-mu-groupe]');
    pilules.forEach(function (p) {
      p.addEventListener('click', function () {
        pilules.forEach(function (x) { x.classList.toggle('is-actif', x === p); });
        var f = p.getAttribute('data-mu-filtre');
        items.forEach(function (it) {
          it.classList.toggle('est-masque', f !== 'tout' && it.getAttribute('data-mu-groupe') !== f);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
